export default __webpack_public_path__ + "static/media/prestashop.e1f2f1e1.png";